import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Re-initialize AOS after every route change so newly mounted
    // elements are detected and their animations play correctly.
    // Without this, elements stay permanently invisible (opacity: 0)
    // when navigating back to a page.
    setTimeout(() => {
      AOS.refreshHard();
    }, 100);
  }, [pathname]);
  return null;
}

export default ScrollToTop;
